export default __webpack_public_path__ + "static/media/master.baeb7162.svg";